<template>
    <section>
        <header :class="[shit$(`h:40px; text-a:c; mb:20px; lh:40px; b:1px; bc:#696969; bl:n!; br:n!; font:12px; letter-s:0.86px; c:#a8a8ac; font-w:500;`)]">{{this.$t( "code-lab/component/file-management/preview.vue_0" ) }}</header>
        <div class="codelab-project-preview" :class="shit$(`overflow:a; h:calc(100% - 60px);`)">
            <template v-if="data">
                <div :class="[shit$(`h:200px; justify-c:c; dis:f;overflow:hidden; `)]">
                    <el-image v-if="decodeScript && data.type$ === 'projectId'" style="width: 100%; height: 100%;" fit="scale-down" :src="util$.formatUrlWithToken$(data.screenshot)" alt=""></el-image>
                    <img :class="shit$('object-fit:contain;')" v-else :src="`${env$}static/images/pic-folder-graphic.png`" />
                </div>
                <p :class="[shit$(`word-wrap:break-word; pr:6px; font-w:500; font:20px; letter-s:1.43px; c:#c8c8c8; mt:13px; lh:1.3;`)]">{{ data.name$ }}</p>
                <ul :class="[shit$(`mt:10px;`)]">
                    <template v-for="(o, i) in previewData">
                        <li v-if="!o['v-if'] || o['v-if']()" :class="[shit$(o.shit), shit$(`font:14px; letter-s:1px;`), i + 1 !== previewData.length && shit$(`mb:8px;`)]" :key="i">{{o.label}}: {{o.content}}</li>
                    </template>
                </ul>
            </template>
            <template v-else>
                <div :class="[shit$(`h:200px; bgc:#333333; font:12px; letter-s:0.86px; text-a:c; lh:24px; center;`)]">{{this.$t( "code-lab/component/file-management/preview.vue_1" ) }}</div>
            </template>
        </div>
    </section>
</template>

<script>
import ToolMix from "@/code-lab/component/file-management/mixins/tool-mix.js";
import { mapState } from "vuex";
const CONSTS = window.CONSTS;
export default {
  mixins: [ToolMix],
  props: {
    data: Object
  },
  data(){
    return{
      blocklyOption: {
        grid: {
          spacing: 10,
          length: 1,
          colour: "#0ed3ff",
          snap: true 
        },
        zoom: {
          controls: false,
          wheel: false,
          maxScale: 3,
          minScale: 0.3,
          scaleSpeed: 1.2,
          startScale: 0.8,
        }
      }
    } 
  },
  computed: {
    ...mapState(["currentVersion", 'env$']),
    previewData() {
      const fn = this.util$.getFormateDate$;
      const groupsName = this.groupsNameT(this.data);
      const data = [
        {
          label: this.$t( "code-lab/component/file-management/preview.vue_2" ),
          content: fn("yyyy/MM/dd hh:mm:ss", new Date(this.data.updatedAt))
        },
        { label: this.$t( "code-lab/component/file-management/preview.vue_3" ), content: this.$t( "code-lab/component/file-management/preview.vue_4" ) },
        {
          label: this.isFolderT(this.data) ? this.$t( "code-lab/component/file-management/preview.vue_5" ) : this.$t( "code-lab/component/file-management/preview.vue_6" ),
          content: this.$t( "code-lab/component/file-management/preview.vue_7" )
        },
        {
          label: this.$t( "code-lab/component/file-management/preview.vue_8" ),
          content: groupsName,
          shit: "lh:1.5;",
          "v-if": () => this.currentVersion === "teacher"
        }
      ];
      return data;
    },
    decodeScript(){
      if(!this.data){
        return null;
      }
      if(!this.data.script){
        return CONSTS.EMPTY_WORK_SPACE;
      }
      return window.nuwa.utils.base64.decode(this.data.script);
    }
  }
};
</script>
<style lang="scss">
  .codelab-project-preview{
    .blocklySvg{
      background-color: transparent;
    }
  }
</style>
